import React, {Component} from 'react';
import  {
    View,
    StatusBar,
    Image,
    TextInput,

    BackHandler,
    Alert,
    TouchableOpacity,
    Platform,
    KeyboardAvoidingView,
    FlatList, ScrollView,
    TouchableHighlight
} from "react-native"

import {verticalScale, moderateScale, scale} from "../../../../tools/Scaling";

import {AsyngStorageClass} from '../../../../tools/AsyngStorageClass';
import DialogConnectionCustomize from "../../../../customviews/DialogConnectionCustomize";
import HMActionBar from "../../../../customviews/HMActionBar";
import HMTextView from "../../../../customviews/HMTextView";
import Colors from "../../../../tools/Colors";
import DialogLoadingCustomize from "../../../../customviews/DialogLoadingCustomize";
import i18n from "../../../../I18n/i18n";
import HMTextInputEfects from "../../../../customviews/HMTextInputEfects";
import store from "../../../../redux/store";
import {typeExport} from "../../../../redux/store/type";
import HMAlert from "../../../../customviews/HMAlert";

let container = null;
let title = null;

export default class ChangeInformationScreen extends Component {
    constructor(props) {
        super(props);
        container = this;
        let {name, family, mobile, token, NationalCode, Phone, SocialNetworkNumber, Address, Description} = store.getState().reducerSplashGetAllData.user;

     //   let navigation =props.route
        title = props.route && props.route.params && props.route.params.type ? props.route.params.item.name : null;

        this.state = {
            FirstName: name,
            LastName: family,
            NationalCode: NationalCode,
            Phone: Phone,
            SocialNetworkNumber: SocialNetworkNumber,
            Address: Address,
            Description: Description,

            pathImage: null,
            Image: null,
            pathFile: null,
            File: null,
            once: true

        }
    }

    componentWillMount() {
        this.getAsyncStorage()
    }

    componentWillReceiveProps(props) {

        //props.resultsSet
        if (this.state.once) {
            this.setState({
                once: false,
                FirstName: "",
                LastName: "",
                NationalCode: null,
                Phone: null,
                SocialNetworkNumber: null,
                Address: null,
                Description: null,
            })
        }

    }

    getAsyncStorage = async () => {

        let token = this.props.token;
        if (token != null) {
            this.setState({
                    FirstName: this.props.user.name,
                    LastName: this.props.user.family
                }
                ,
                () => {
                }
            )
        } else {

            this.props.navigation.navigate("LoginEnterPhoneScreen", {type_login: "changeInfo"});
        }
    }

    async setInfoUser(user, token, LastName, name) {
        this.props.callServiceSetUser(user)
        this.props.callServiceSetWallet(user.credit, 2)
        const value = await AsyngStorageClass.setInfoUser(token, LastName, name);
        if (value) {
        } else {
            alert(i18n.t('constant.retry'))
        }
    }

    setDate() {
        this.setState({once: true}, () => {
            let paramss = {
                "_operation": typeExport._Contacts,
                "mode": "SaveTickets",
                "lang": i18n.locale,
                "token": store.getState().reducerSplashGetAllData.token,

                "firstname": this.state.FirstName,
                "lastname": this.state.LastName,
                "NationalCode": this.state.NationalCode,
                "Phone": this.state.Phone,
                "SocialNetworkNumber": this.state.SocialNetworkNumber,
                "Address": this.state.Address,
                "Description": this.state.Description,

                //"token_fb": this.props.DataSplashScreen.token_fb,
            };
            this.props.callService(
                typeExport.urlGetChangeInformationScreen,
                //`?token=${this.state.token}&name=${this.state.name.value}&LastName=${this.state.LastName.value}`,
                //  `?name=${this.state.FirstName.value}&family=${this.state.LastName.value}`,
                paramss,
                typeExport.TypegetDataChangeInformationScreen,
                "POST",
                this.props.token
            );
        });


    }

    getDate() {
        this.setState({once: true}, () => {
            let paramss = {
                "_operation": typeExport._Contacts,
                "mode": "SaveTickets",
                "lang": i18n.locale,
                "token": store.getState().reducerSplashGetAllData.token,

                "firstname": this.state.FirstName,
                "lastname": this.state.LastName,


                //"token_fb": this.props.DataSplashScreen.token_fb,
            };
            this.props.callService(
               typeExport. urlGetChangeInformationScreen,
                //`?token=${this.state.token}&name=${this.state.name.value}&LastName=${this.state.LastName.value}`,
                //  `?name=${this.state.FirstName.value}&family=${this.state.LastName.value}`,
                paramss,
                typeExport.TypegetDataChangeInformationScreen,
                "POST",
                this.props.token
            );
        });
    }

    checkInput() {

        let {FirstName, LastName, SocialNetworkNumber} = this.state;

        if (FirstName && FirstName.trim().length > 1) {
            if (LastName && LastName.trim().length > 1) {


                    this.setDate();
            }
            else {
                HMAlert(
                    i18n.t('constant.message'),
                    i18n.t('constant.LastName') + " " + i18n.t('constant.MustContainOneCharacter'),

                    [
                        // {text: 'Ask me later', onPress: () => {}},
                        // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
                        {
                            text: i18n.t('constant.ok'), onPress: () => {
                            }
                        },
                    ],
                    {cancelable: true}
                )
                //alert('حداقل باید ۱۰ کاراکتر باشد')


            }


        } else {
            HMAlert(
                i18n.t('constant.message'),
                i18n.t('constant.EnterYourNameCorrectly'),
                [
                    // {text: 'Ask me later', onPress: () => {}},
                    // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
                    {
                        text: i18n.t('constant.ok'), onPress: () => {
                        }
                    },
                ],
                {cancelable: true}
            )
        }


    }

    _changeTextFirstName(text) {
        this.setState({
            FirstName: {
                value: text,
                error: ''
            }
        });
    }

    _changeTextLastName(text) {
        this.setState({
            LastName: {
                value: text,
                error: ''
            }
        });
    }

    _checkDisplay(field) {
        return {display: field === '' ? 'none' : 'flex'}
    }


    _onRef = (property, view) => {
        container[property] = view
    }

    _focusNextField(nextField) {
        container[nextField].focus()
  /*      container[nextField].input.current.measureLayout(
            ReactNative.findNodeHandle(container._scroll),
            (x, y) => {
                container._scroll.scrollTo({x: 0, y: y - moderateScale(40), animated: true});
            }
        );*/
    }

    render() {
        // const FirstNameError = this.state.FirstName.error;
        // const LastNameError = this.state.LastName.error;

        let birthDay = this.state[`finalDateBirthDay`];
        return (
            <View style={{position: 'relative', flex: 1, backgroundColor: Colors.white}}>
                <View style={{position: 'absolute', top: 0, bottom: 0, left: 0, right: 0}}>
                    <KeyboardAvoidingView style={{width: "100%", height: "100%"}} behavior={"padding"}
                                          enabled={Platform.OS === "ios"}>
                        <View style={{flex: 1,}}>
                            <HMActionBar
                                props={this.props} statusBarTransparent
                                text={title ? title : i18n.t('ChangeInformation.title')}

                                //  text={i18n.t('constant.Information')}

                                //menu={false}
                                back
                                headerVisibility more_menu
                                onBackPress={() => this.props.navigation.pop()}

                            />
                            <ScrollView
                                ref={scroll => this._scroll = scroll}
                                keyboardShouldPersistTaps="handled"


                            >
                                {/*<View style={{marginTop: moderateScale(20)}}>*/}
                                {/*/!*   <HMTextView text="نام و نام خانوادگی" type={"bold"} style={{*/}
                                {/*marginEnd: moderateScale(20),*/}
                                {/*fontSize: moderateScale(15),*/}
                                {/*textAlign: "right"*/}
                                {/*}}/>*!/*/}

                                {/*<HMTextInputEfects*/}
                                {/*value={this.state.FirstName.value}*/}
                                {/*type={"Fumi"}*/}
                                {/*label={i18n.t('constant.First_name')}*/}
                                {/*onChangeText={text => this._changeTextFirstName(text)}*/}
                                {/*iconClass={"FontAwesome"}*/}
                                {/*iconName={'user'}*/}
                                {/*// secureTextEntry={true}*/}
                                {/*/>*/}


                                {/*/!*                <HMTextInput style={{width: '90%'}} value={this.state.name.value}*/}
                                {/*onChangeText={text => this._changeTextName(text)}/>*!/*/}
                                {/*<HMTextView text={i18n.t('constant.MustContainOneCharacter')}*/}
                                {/*style={[this._checkDisplay(FirstNameError), {*/}
                                {/*textAlign: "right",*/}
                                {/*fontSize: moderateScale(13),*/}
                                {/*color: "red",*/}
                                {/*marginHorizontal: moderateScale(20),*/}
                                {/*}]}/>*/}

                                {/*/!*            <HMTextView text={i18n.t('constant.address')} type={"bold"} style={{*/}
                                {/*marginEnd: moderateScale(20),*/}
                                {/*fontSize: moderateScale(15),*/}
                                {/*marginTop: moderateScale(7),*/}
                                {/*textAlign: "right"*/}
                                {/*}}/>*!/*/}
                                {/*/!*  <HMTextInput style={{width: '90%'}} value={this.state.LastName.value} _multiline*/}
                                {/*_height={120}*/}
                                {/*onChangeText={text => this._changeTextaddress(text)}/>*!/*/}
                                {/*<HMTextInputEfects*/}
                                {/*value={this.state.LastName.value}*/}
                                {/*type={"Fumi"}*/}
                                {/*label={i18n.t('constant.Last_name')}*/}
                                {/*onChangeText={text => this._changeTextLastName(text)}*/}
                                {/*iconClass={"FontAwesome"}*/}
                                {/*iconName={'users'}*/}
                                {/*//   secureTextEntry={true}*/}
                                {/*/>*/}
                                {/*<HMTextView text={i18n.t('constant.MustContainOneCharacter')}*/}
                                {/*style={[this._checkDisplay(LastNameError), {*/}
                                {/*textAlign: "right",*/}
                                {/*fontSize: moderateScale(13),*/}
                                {/*color: "red",*/}
                                {/*marginHorizontal: moderateScale(20),*/}
                                {/*}]}/>*/}
                                {/*</View>*/}
                                {/*<AnimateLoadingButton*/}
                                {/*ref={c => (this.loadingButton = c)}*/}
                                {/*width={moderateScale(300)}*/}
                                {/*height={verticalScale(50)}*/}
                                {/*title="ویرایش"*/}
                                {/*titleFontFamily={Constants.regularFontName}*/}
                                {/*containerStyle={{marginTop: moderateScale(20)}}*/}
                                {/*titleFontSize={moderateScale(16)}*/}
                                {/*titleColor="rgb(255,255,255)"*/}
                                {/*backgroundColor={colorPrimary}*/}
                                {/*borderRadius={4}*/}

                                {/*onPress={() => this.checkInput()}*/}
                                {/*/>*/}

                                {/*/////////////////*/}
                                <View style={{alignItems: 'center', width: '100%'}}>
                                    <HMTextInputEfects
                                        onRef={scroll => container["inputFirstName"] = scroll}

                                        refName={"FirstName"}

                                        type={"CostumeFumi"}
                                        value={this.state.FirstName}

                                        label={i18n.t('constant.FirstName')}
                                        onChangeText={text => this.setState({
                                            FirstName: text
                                        })}
                                        iconClass={"FontAwesome"}
                                        iconName={'phone'}
                                        //keyboardType={'number-pad'}
                                        // _scroll={this._scroll}

                                        // secureTextEntry={true}
                                        onSubmitEditing={() => this._focusNextField("inputLastName")}
                                        containerStyle={{}}
                                        containerInputStyle={{
                                            borderWidth: moderateScale(1),

                                            borderRadius: moderateScale(10),
                                            // overflow: 'hidden',
                                            marginVertical: moderateScale(4),

                                        }}
                                        border={true}
                                        requireField
                                        //height={moderateScale(40)}
                                        styleRoot={{
                                            width: "100%", alignItems: 'center',
                                            justifyContent: 'center',
                                        }}
                                    />

                                    <HMTextInputEfects
                                        onRef={scroll => container["inputLastName"] = scroll}

                                        refName={"LastName"}

                                        type={"CostumeFumi"}
                                        value={this.state.LastName}

                                        label={i18n.t('constant.LastName')}
                                        onChangeText={text => this.setState({
                                            LastName: text
                                        })}
                                        iconClass={"FontAwesome"}
                                        iconName={'phone'}
                                        //keyboardType={'number-pad'}
                                        // _scroll={this._scroll}

                                        // secureTextEntry={true}
                                        onSubmitEditing={() => this._focusNextField("inputNationalCode")}
                                        containerStyle={{}}
                                        containerInputStyle={{
                                            borderWidth: moderateScale(1),

                                            borderRadius: moderateScale(10),
                                            // overflow: 'hidden',
                                            marginVertical: moderateScale(4)
                                        }}
                                        border={true}
                                        requireField
                                        styleRoot={{
                                            width: "100%", alignItems: 'center',
                                            justifyContent: 'center',
                                        }}
                                    />



                                    <TouchableOpacity
                                        style={{
                                            backgroundColor: Colors.colorPrimary,
                                            width: "93%",
                                            height: moderateScale(40),
                                            alignItems: "center",
                                            justifyContent: "center",
                                            alignSelf: 'center',
                                            marginTop: moderateScale(16),
                                            marginBottom: moderateScale(5),
                                            borderRadius: moderateScale(8),
                                            //marginEnd: moderateScale(10)
                                            //  marginHorizontal:moderateScale(10)
                                            // borderRadius:moderateScale(2)
                                        }}
                                        onPress={() => {
                                            this.checkInput()
                                        }}

                                    >
                                        <View style={{
                                            flexDirection: "row",
                                            alignItems: "center",
                                            justifyContent: "center"
                                        }}>
                                            <HMTextView type={"bold"}
                                                        text={title ? "ثبت نام در مسابقه" : i18n.t('constant.Edit')}
                                                        style={{
                                                            color: "white",
                                                            fontSize: moderateScale(16),
                                                            //   marginEnd: moderateScale(10),

                                                        }}/>

                                        </View>
                                    </TouchableOpacity>
                                </View>
                            </ScrollView>


                            {/*/////////////////*/}


                      {/*      {
                                this.state.showDialogDate ?
                                    <HMDatePicker
                                        NameDate={"BirthDay"}
                                        setStateData={this._setStateData}

                                        DateTo={this.state.DateTo}
                                        DateFrom={this.state.DateFrom}
                                        onPressOk={this.setDate}
                                        onPressCancel={() => {
                                            this.setState({
                                                showDialogDate: false
                                            })
                                        }}
                                    />
                                    :
                                    null
                            }*/}
                         {/*   <HMModal
                                isVisible={this.state.visibleModal === 'selectImage' || this.state.visibleModal === 'selectVideo'}
                                backdropColor={Colors.gray}
                                backdropOpacity={0.8}
                                animationIn="zoomInDown"
                                animationOut="zoomOutUp"
                                animationInTiming={600}
                                animationOutTiming={600}
                                backdropTransitionInTiming={600}
                                backdropTransitionOutTiming={600}
                                //style={{height: '60%'}}
                                onBackdropPress={() => this.hiddenModal()}
                                onBackButtonPress={() => this.hiddenModal()}
                            >

                                <View style={{
                                    //  height: "90%",
                                    padding: moderateScale(6),
                                    backgroundColor: Colors.white
                                }}>
                                    {
                                        this.state.visibleModal === "selectImage" ?

                                            <View>
                                                <TouchableOpacity
                                                    onPress={() => {
                                                        ImagePicker.openCamera(typeExport.optional).then(image => {
                                                            //   alert((image.size / 1048576).toFixed(2) + " mb")
                                                            this.setState({
                                                                Image: image,
                                                                pathImage: image.path,
                                                                visibleModal: ''
                                                            })
                                                        });
                                                    }}
                                                    style={{
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        backgroundColor: '#eee',
                                                        margin: moderateScale(5),
                                                        padding: moderateScale(8),
                                                        borderRadius: moderateScale(4)
                                                    }}>
                                                    <HMTextView
                                                        text={"گرفتن عکس"}
                                                        type={'bold'}
                                                        style={{
                                                            alignSelf: 'center',
                                                            //  marginRight: moderateScale(6),
                                                            // margin: moderateScale(6),
                                                            textAlign: 'center',
                                                            color: Colors.colorDarkText,
                                                            fontSize: moderateScale(14),
                                                        }}/>
                                                </TouchableOpacity>
                                                <TouchableOpacity
                                                    onPress={() => {
                                                        ImagePicker.openPicker({
                                                            width: 1000,
                                                            height: 1000,
                                                            cropping: true
                                                        }).then(image => {
                                                            this.setState({
                                                                //ShowImage:true
                                                                visibleModal: '',
                                                                pathImage: image.path,
                                                                Image: image,
                                                            })
                                                        });
                                                    }}
                                                    style={{
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        backgroundColor: '#eee',
                                                        padding: moderateScale(8),
                                                        margin: moderateScale(5),
                                                        borderRadius: moderateScale(4)
                                                    }}>
                                                    <HMTextView
                                                        text={"انتخاب عکس از گالری"}
                                                        type={'bold'}
                                                        style={{
                                                            alignSelf: 'center',
                                                            //  marginRight: moderateScale(6),
                                                            // margin: moderateScale(6),
                                                            textAlign: 'center',
                                                            color: Colors.colorDarkText,
                                                            fontSize: moderateScale(14),
                                                        }}/>
                                                </TouchableOpacity>
                                            </View>
                                            :
                                            <View>
                                                <TouchableOpacity
                                                    onPress={() => {
                                                        ImagePicker.openCamera({
                                                            mediaType: 'video',
                                                        }).then(video => {


                                                            this.compressVideo(video)

                                                        });
                                                    }}
                                                    style={{
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        backgroundColor: '#eee',
                                                        margin: moderateScale(5),
                                                        padding: moderateScale(8),
                                                        borderRadius: moderateScale(4)
                                                    }}>
                                                    <HMTextView
                                                        text={"گرفتن فیلم"}
                                                        type={'bold'}
                                                        style={{
                                                            alignSelf: 'center',
                                                            //  marginRight: moderateScale(6),
                                                            // margin: moderateScale(6),
                                                            textAlign: 'center',
                                                            color: Colors.colorDarkText,
                                                            fontSize: moderateScale(14),
                                                        }}/>
                                                </TouchableOpacity>
                                                <TouchableOpacity
                                                    onPress={() => {
                                                        ImagePicker.openPicker({
                                                            mediaType: "video",
                                                        }).then((video) => {

                                                            this.compressVideo(video)
                                                        });
                                                    }}
                                                    style={{
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        backgroundColor: '#eee',
                                                        padding: moderateScale(8),
                                                        margin: moderateScale(5),
                                                        borderRadius: moderateScale(4)
                                                    }}>
                                                    <HMTextView
                                                        text={"انتخاب فیلم از گالری"}
                                                        type={'bold'}
                                                        style={{
                                                            alignSelf: 'center',
                                                            //  marginRight: moderateScale(6),
                                                            // margin: moderateScale(6),
                                                            textAlign: 'center',
                                                            color: Colors.colorDarkText,
                                                            fontSize: moderateScale(14),
                                                        }}/>
                                                </TouchableOpacity>
                                            </View>
                                    }


                                </View>
                            </HMModal>*/}

                            {
                                this.props.NoInternetDialog ?
                                    <DialogConnectionCustomize
                                        again
                                        onPress={() => {
                                            // this.loadingButton.showLoading(false),
                                            this.props.callserviceActionRefresh()
                                        }}
                                    />
                                    :
                                    null
                            }
                            {
                                this.props.isLoading ?
                                    <DialogLoadingCustomize/>
                                    : null
                            }
                        </View>
                    </KeyboardAvoidingView>
                </View>
            </View>
        );
    }

    hiddenModal() {
        this.setState({
                visibleModal: ''
            },
            async () => {
                // this.state.recording?   await this._stop():null
            }
        )
    }

    async onShow(data) {


        this.setState({
            visibleModal: data,
            Modalcategory: true,
            //    audioPath: p,
        });
    }

// _setStateData(name, data) {
//     container.setState({[name]: data});
// }
    _setStateData(data) {
        container.setState(data, () => {
            // alert(container.state[`finalDateBirthDay`]+"   --- "+ container.state.ggggggg);

        });
    }
}
